export class AllotmentCondition {
  constructor(online) {
    this.online = online
    this.total_hotel_occupancy_format = 'PERCENTAGE'
    this.total_room_occupancy_format = 'PERCENTAGE'
  }
}

export class Action {
  constructor() {
    this.discount_from_room_type_ids = []
    this.channels_online = false
    this.channel_ids = []
    this.apply_to_dto = {
      channels_online: true,
    }
    this.min_occ_before = 0
    this.min_occ_after = 0
    this.min_occ = 0
    this.consecutive_days = 1
  }
}

export class Allotment {
  constructor() {
    this.update_in_realtime = false
  }
}
